// src/pages/Dashboard/components/CoachCard.jsx
// STATUS: active | UPDATED: 2026-08-02
// LOG:
//   2026-08-02  Header standardized; Phase 1 checkpoint committed (e765830).
//   2026-08-01  Links to real /coach/ with current-step context
// The door to the live J13 Coach. Personalizes the invitation with the user's
// current step so the nudge is specific, then routes to /coach/.

import { useNavigate } from 'react-router-dom'
import { Box, HStack, Text, Flex, Icon, Button } from '@chakra-ui/react'
import { Sparkles, ArrowRight } from 'lucide-react'

export default function CoachCard({ firstName, currentStep }) {
  const navigate = useNavigate()
  return (
    <Box bg="ink" color="onInk" borderRadius="cardLg" p={6} position="relative" overflow="hidden">
      <HStack spacing={3} mb={4}>
        <Flex w={8} h={8} borderRadius="full" bg="onInkFill" align="center" justify="center">
          <Icon as={Sparkles} boxSize={4} color="onInk" />
        </Flex>
        <Text fontSize="xs" fontWeight={600} letterSpacing="0.08em" textTransform="uppercase" color="onInkMuted">
          Your coach
        </Text>
      </HStack>
      <Text fontSize="md" lineHeight={1.6} color="onInkStrong" maxW="52ch" mb={5}>
        {/* The name carries the capital when we have one. Without it the
            sentence has to start itself, or the card opens lowercase. */}
        {firstName ? `${firstName}, ` : ''}
        {currentStep
          ? `${firstName ? "you're" : "You're"} on Step ${currentStep.number}, ${currentStep.title}. I can quiz you on it, play the customer or talk through your next one.`
          : `${firstName ? 'ready' : 'Ready'} to sharpen up? I can run role-play, quiz you on any step or talk through your next customer.`}
      </Text>
      <Button
        bg="card"
        color="ink"
        size="sm"
        minH="40px"
        _hover={{ bg: 'onInkStrong' }}
        _active={{ bg: 'onInkMuted' }}
        rightIcon={<ArrowRight size={15} />}
        onClick={() => navigate('/coach/')}
      >
        Talk to the Coach
      </Button>
    </Box>
  )
}
